import React, { useEffect, useState } from 'react';
import { usePAChecklist } from "../pa_checklist_context";
import styles from '../pa_checklist.module.scss'
import Tabela from '../../../Misc/Tabela/Tabela';
import { Modal, Button } from 'react-bootstrap';
import { isNullish } from '../../../../utils/misc_utils';
import ValidationStatusCell from './pa_checklist_modal_caixa_farol';

const PAChecklistModalCaixa = () => {
  const { limparItemsSelecionadosCaixa, modalCaixa, romaneioSelecionado, setModalCancelamento, formularioCaixa, setFormularioCaixa, setItemEmAnaliseCaixa, setSubModalCaixa, processarChecklistCaixa, setIdsCancelamento, listaProducoesRomaneioSelecionado } = usePAChecklist();

  const [listaProducoesNaoProcessadas, setListaProducoesNaoProcessadas] = useState([]);
  const [listaProducoesJaProcessadas, setListaProducoesJaProcessadas] = useState([]);
  const [entradasSelecionadas, setEntradasSelecionadas] = useState([]);
  const [quantidadeSelecionada, setQuantidadeSelecionada] = useState(0);

  useEffect(() => {
    const jaProcessados = [];
    const naoProcessados = [];
    listaProducoesRomaneioSelecionado.map(item => {
      if (item.checklist_ok || item.romaneio_nf_saida) return jaProcessados.push(item);
      return naoProcessados.push(item);
    });
    setListaProducoesJaProcessadas([...jaProcessados]);
    setListaProducoesNaoProcessadas([...naoProcessados]);

    setFormularioCaixa([
      ...naoProcessados.map(item => ({
        id_entrada_fiscal: item.id_entrada_fiscal,
        possui_peca_piloto: null,
        preco_tag_divergente: { key: false, value: '' },
        composicao_tag_divergente: { key: false, value: null }
      }))
    ]);
  }, []);

  useEffect(() => {
    let novaQuantidade = 0;
    for (const item of romaneioSelecionado.dados_produto) {
      if (
        entradasSelecionadas.some(prod =>
          prod.produto === item.produto &&
          prod.cor_produto === item.cor_produto
        )
        ||
        listaProducoesJaProcessadas.some(prod =>
          prod.produto === item.produto &&
          prod.cor_produto === item.cor_produto
        )
      ) {
        novaQuantidade += item.qtde_entrada;
      }
    }
    setQuantidadeSelecionada(novaQuantidade);
  }, [entradasSelecionadas, listaProducoesJaProcessadas]);

  const analisarItemCaixa = (row, index) => {
    setItemEmAnaliseCaixa({ ...row, index });
    setSubModalCaixa(true);
  }

  const caixaColumns = [
    {
      cell: (row, index) => {
        return (
          <Button
            style={{ fontWeight: '500' }}
            variant={'primary'}
            onClick={() => analisarItemCaixa(row, index)}
            disabled={
              (!entradasSelecionadas.some(es => es.id_entrada_fiscal === row.id_entrada_fiscal))
              ||
              (row.romaneio_nf_saida || row.checklist_ok)
            }
          >
            Análise
          </Button>
        )
      }
    },
    {
      name: 'Piloto ok? | Preço ok? | Comp. ok?',
      cell: (_, index) => {
        if (!formularioCaixa[index]) return;
        const { possui_peca_piloto, preco_tag_divergente, composicao_tag_divergente } = formularioCaixa[index];
        return (
          <ValidationStatusCell
            piloto={
              possui_peca_piloto === null ? 'error' :
                possui_peca_piloto === false ? 'warning' : 'ok'
            }
            preco={
              (preco_tag_divergente.key === true && isNullish(preco_tag_divergente.value)) ? 'error' :
                (preco_tag_divergente.key === true && preco_tag_divergente.value) ? 'warning' : 'ok'
            }
            composicao={
              (composicao_tag_divergente.key === true && isNullish(composicao_tag_divergente.value)) ? 'error' :
                (composicao_tag_divergente.key === true && composicao_tag_divergente.value) ? 'warning' : 'ok'
            }
          />
        )
      },
      width: '240px'
    },
    { name: 'ID Entrada', selector: row => row.id_entrada_fiscal },
    { name: 'NF Entrada', selector: row => row.nf_entrada },
    { name: 'Série', selector: row => row.serie_nf },
    { name: 'Produto', selector: row => row.produto },
    { name: 'Cor Produto', selector: row => row.cor_produto },
    { name: 'Qtde. Entrada', selector: row => row.qtde_entrada },
    { name: 'Origem', selector: row => row.origem, wrap: true },
    { name: 'Data Entrada', selector: row => row.data_entrada_revisao_br },
    { name: 'Filial Revisão', selector: row => row.filial_revisao, width: '260px' }
  ];

  const caixaColumnsJaProcessadas = [
    { name: 'ID Entrada', selector: row => row.id_entrada_fiscal },
    { name: 'Possui Peça Piloto', selector: row => row.possui_peca_piloto ? 'Sim' : 'Não' },
    { name: 'Preço Tag Divergente', selector: row => row.preco_tag_divergente ? row.preco_tag_divergente : '-' },
    { name: 'Composição Tag Divergente', selector: row => row.composicao_tag_divergente ? row.composicao_tag_divergente : '-' },
    { name: 'NF Entrada', selector: row => row.nf_entrada },
    { name: 'Série', selector: row => row.serie_nf },
    { name: 'Produto', selector: row => row.produto },
    { name: 'Cor Produto', selector: row => row.cor_produto },
    { name: 'Qtde. Entrada', selector: row => row.qtde_entrada },
    { name: 'Origem', selector: row => row.origem, wrap: true },
    { name: 'Data Entrada', selector: row => row.data_entrada_revisao_br },
    { name: 'Filial Revisão', selector: row => row.filial_revisao, width: '260px' }
  ];

  return (
    <Modal
      show={modalCaixa}
      centered={true}
      backdrop={'static'}
      fullscreen={true}
    >
      <Modal.Header style={{ fontWeight: '500' }}>
        Romaneio NF Saída | {romaneioSelecionado.romaneio_nf_saida}&nbsp;-&nbsp;
        Quantidade no Romaneio | {quantidadeSelecionada}/{romaneioSelecionado.qtde_recebida}&nbsp;
        {listaProducoesJaProcessadas.length > 0 && '- (Romaneio já Processado)'}

        <Button
          variant={'danger'}
          className={styles.footer_btn_processamento}
          style={{ marginLeft: 'auto' }}
          onClick={() => {
            setModalCancelamento(true);
            setIdsCancelamento(listaProducoesRomaneioSelecionado.map(obj => obj.id_controle));
          }}
        >
          Cancelar Análise
        </Button>
      </Modal.Header>
      <Modal.Body>
        <div className={styles.produtos_wrapper}>
          {romaneioSelecionado.dados_produto.map((item, index) => {
            return (
              <div
                className={styles.produto_data_wrapper}
                style={{
                  backgroundColor: 
                    entradasSelecionadas.some(sel => (sel.produto === item.produto && sel.cor_produto === item.cor_produto)) ||
                    listaProducoesJaProcessadas.some(sel => (sel.produto === item.produto && sel.cor_produto === item.cor_produto))
                    ? '#4CAF5090' : '#DDD'
                }}
                key={`chave_prod_cor_${index}`}
              >
                <div>Produto | {item.produto}</div> -
                <div>Cor Produto | {item.cor_produto}</div> -
                <div>Quantidade | {item.qtde_entrada}</div>
              </div>
            );
          })}
        </div>

        <hr />

        <h6>Produções não processadas possíveis</h6>
        <Tabela
          columns={caixaColumns}
          data={listaProducoesNaoProcessadas}
          pending={false}
          pagination={false}
          highlightOnHover={true}
          selectableRows={true}
          selectableRowDisabled={row => (listaProducoesJaProcessadas.length > 0)}
          onSelectedRowsChange={obj => setEntradasSelecionadas(obj.selectedRows)}
          clearSelectedRows={limparItemsSelecionadosCaixa}
        />

        <hr />

        <h6>Produções já processadas no romaneio {romaneioSelecionado.romaneio_nf_saida}</h6>
        <Tabela
          columns={caixaColumnsJaProcessadas}
          data={listaProducoesJaProcessadas}
          pending={false}
          pagination={false}
          highlightOnHover={true}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant={'success'}
          className={styles.footer_btn_processamento}
          onClick={() => processarChecklistCaixa(entradasSelecionadas)}
          style={{ width: '30%' }}
          disabled={
            (quantidadeSelecionada !== romaneioSelecionado.qtde_recebida)
            || entradasSelecionadas.length === 0
            || listaProducoesJaProcessadas.length > 0
          }
        >
          {listaProducoesJaProcessadas.length === 0 ? 'Processar' : 'Romaneio já Processado'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PAChecklistModalCaixa;
